var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobStoppedSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346 -61)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.88,
    height: 7.88,
    transform: "translate(351.06 66.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.125A7.875,7.875,0,1,1,1.125,9,7.884,7.884,0,0,1,9,1.125M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z",
    transform: "translate(346 61)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobStoppedSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job-stopped-solid.2bcf5feb8228c715abb1530e75d83b9e.svg";